(function(){
  'use strict';
  document.querySelectorAll('.sr-mobile-nav a').forEach(function(l){
    l.addEventListener('click',function(){document.querySelector('.sr-mobile-nav').classList.remove('is-open')});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){var n=document.querySelector('.sr-mobile-nav');if(n)n.classList.remove('is-open')}});
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target)}})},{threshold:0.1});
    document.querySelectorAll('.sr-reveal').forEach(function(el){obs.observe(el)});
  }
  var h=document.querySelector('.sr-header__inner');
  if(h){window.addEventListener('scroll',function(){h.style.height=window.scrollY>80?'56px':'72px'},{passive:true})}

  /* Carousel — works with any direct children of the track */
  document.querySelectorAll('[data-carousel]').forEach(function(c){
    var track=c.querySelector('[data-carousel-track]'),prev=c.querySelector('[data-carousel-prev]'),next=c.querySelector('[data-carousel-next]'),dots=c.querySelector('[data-carousel-dots]');
    if(!track)return;
    var items=track.children;
    var cur=0,total=items.length;
    if(total<1)return;

    if(dots&&total>1){
      for(var i=0;i<total;i++){
        var d=document.createElement('button');
        d.className='sr-featured__dot'+(i===0?' is-active':'');
        d.dataset.index=i;
        d.addEventListener('click',function(){go(parseInt(this.dataset.index))});
        dots.appendChild(d);
      }
    }
    function go(n){
      if(n<0)n=total-1;if(n>=total)n=0;cur=n;
      track.style.transform='translateX(-'+cur*100+'%)';
      track.style.transition='transform .4s ease';
      if(dots)dots.querySelectorAll('.sr-featured__dot').forEach(function(d,i){d.classList.toggle('is-active',i===cur)});
    }
    if(prev)prev.addEventListener('click',function(){go(cur-1)});
    if(next)next.addEventListener('click',function(){go(cur+1)});
    var sx=0,dx=0;
    track.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;dx=0},{passive:true});
    track.addEventListener('touchmove',function(e){dx=e.touches[0].clientX-sx},{passive:true});
    track.addEventListener('touchend',function(){if(Math.abs(dx)>50){dx<0?go(cur+1):go(cur-1)}});
  });
})();
